export default __webpack_public_path__ + "assets/images/f469a717be201692c02d796e741b7dab.svg";